import React, { useEffect, useState } from 'react';
import { GroupedFeatures, ObjectFeature } from '../../types/ObjectTypes';
import { getGroupedFeaturesByCategory } from '../../services/Object/ObjectFeaturesService';
import { VStack, Text, Wrap, Icon, Divider, Flex, WrapItem } from '@chakra-ui/react';
import { BsCheck } from 'react-icons/all';

interface objectDetailFeatureInterface {
  features: Array<ObjectFeature>;
  isLoading: Boolean;
}

export const ObjectFeatures = ({
  features,
  isLoading,
}: objectDetailFeatureInterface): JSX.Element => {
  const [groupedFeatures, setGroupedFeatures] = useState<GroupedFeatures[]>([]);

  useEffect(() => {
    setGroupedFeatures(getGroupedFeaturesByCategory(features));
  }, [features]);
  return (
    <>
      {!isLoading && (
        <VStack
          p={4}
          borderRadius={{ sm: 0, md: 0, lg: 0, xl: 4 }}
          borderWidth={1}
          borderColor={'gray.300'}
          backgroundColor={'white'}
          overflow={{ base: 'auto', md: 'unset' }}
          w="full"
          gridGap={4}
          flex={1}
          h={{ base: 'calc(100% - 56px)', md: 'unset' }}>
          <Text w={'100%'} textAlign={'left'} fontSize={'xl'} textStyle={'category.primary'}>
            Ausstattung
          </Text>
          <VStack width={'100%'}>
            {groupedFeatures.map((groupedFeature, idx) => {
              return (
                <VStack width={'100%'} gridGap={4} key={idx}>
                  <Divider />

                  <Text
                    fontWeight={'semibold'}
                    fontSize={'md'}
                    color={'gray.700'}
                    flex={1}
                    width={'100%'}>
                    {groupedFeature.category}
                  </Text>

                  <Wrap width={'100%'} pl={12} pr={12} justifyContent={'flex-start'}>
                    {groupedFeature.features.map((feature, idx) => {
                      return (
                        <WrapItem key={idx}>
                          {feature.FieldType !== 'DYNAMIC' && (
                            <Icon as={BsCheck} color={'green.400'} fontSize={'2xl'} mr={2} />
                          )}
                          <Text color={'gray.500'} pr={8}>
                            {feature.Title}
                            {feature.FieldType === 'DYNAMIC' && <>: {feature.Content}</>}
                          </Text>
                        </WrapItem>
                      );
                    })}
                  </Wrap>
                </VStack>
              );
            })}
          </VStack>
        </VStack>
      )}
    </>
  );
};
